import React from "react";
import Slide from "../Slide/Slide";

const Testimonial = () => {
  return (
    <div className="mb-20">
      <h1 className="text-center text-orange-600 text-3xl font-bold pb-3">
        Testimonial
      </h1>
      <p className="text-center text-5xl  font-bold pb-3">What Customer Says</p>
      <Slide></Slide>
    </div>
  );
};

export default Testimonial;
